export default "__VITE_ASSET__BgdH42Di__"